import React, { useEffect, useState } from 'react';
import {
  TrendingUp,
  RotateCcw,
  EyeOff,
  CheckCircle,
  Plus,
  Trash2,
  Edit3,
  XCircle,
  MinusCircle,
} from 'lucide-react';
import PageHeading from '../../components/PageHeading/PageHeading';
import MuiTable from '../../components/MuiTable/MuiTable';
import Dropdown from '../../components/Dropdown/Dropdown';
import {
  updateDownloadID,
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import qs from 'qs';
import axiosInstance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import { StateProps } from '../../redux/reducer';
import { markedDmcaCountLables } from '../../config/constants';

const columns = [
  {
    id: 'date',
    label: 'Date',
    minWidth: 120,
    align: 'left',
  },
  {
    id: 'loginTime',
    label: 'Login Time',
    minWidth: 120,
    align: 'left',
  },
  {
    id: 'logoutTime',
    label: 'Logout Time',
    minWidth: 120,
    align: 'left',
  },
];
const column2 = [
  {
    id: 'date',
    label: 'Date',
    minWidth: 150,
    align: 'left',
  },
  {
    id: 'name',
    label: 'Name',
    minWidth: 150,
    align: 'left',
  },
  {
    id: 'src-download',
    label: 'Source File',
    minWidth: 0,
    align: 'center',
  },
  {
    id: 'action',
    label: 'Action',
    minWidth: 0,
    align: 'right',
  },
];

// Mock data for categories
const categoryData = {
  createdCount: 245,
  activatedCount: 189,
  deactivatedCount: 67,
  deletedCount: 56,
};

const categoryLabels = {
  created: 'Created',
  activated: 'Activated',
  deactivated: 'Deactivated',
  deleted: 'Deleted',
};

// Mock data for keywords
const keywordData = {
  createdCount: 156,
  deletedCount: 23,
  modifiedCount: 89,
};

const keywordLabels = {
  created: 'Created',
  deleted: 'Deleted',
};

const UserActivity = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const currentDate = new Date();
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const [keywordActivity, setKeywordActivity] = useState<any>({
    startDate: new Date(currentDate.getTime() - 86400000 * 7),
    endDate: new Date(),
    range: '',
  });
  const [categoryActivity, setCategoryActivity] = useState<any>({
    startDate: new Date(currentDate.getTime() - 86400000 * 7),
    endDate: new Date(),
    range: '',
  });

  const [loginActivity, setLoginActivity] = useState<any>({
    startDate: new Date(currentDate.getTime() - 86400000 * 7),
    endDate: new Date(),
    range: '',
  });
  const [markedDMCA, setMarkedDMCA] = useState<any>({
    startDate: new Date(currentDate.getTime() - 86400000 * 7),
    endDate: new Date(),
    range: '',
  });
  const [generatedDMCA, setGeneratedDMCA] = useState<any>({
    startDate: new Date(currentDate.getTime() - 86400000 * 7),
    endDate: new Date(),
    range: '',
  });
  const [keywordResponse, setKeywordResponse] = useState<any>({});
  const [categoryResponse, setCategoryResponse] = useState<any>({});
  const [loginResponse, setLoginResponse] = useState<any>([]);
  const [pieChartResponse, setPieChartResponse] = useState<any>({});
  const [dmcaResponse, setDmsaResponse] = useState<any>([]);

  useEffect(() => {
    if (localStorage.breadcrumbData === 'User') {
      const breadcrumb = [
        { path: '/users', name: 'Users' },
        { path: `/userDetails/${id}`, name: 'User Details' },
        { path: `/userActivity/${id}`, name: 'User Activity' },
      ];
      dispatch(update_breadcrumb(breadcrumb));
    } else {
      const breadcrumb = [
        { path: '/profile', name: 'Profile' },
        { path: `/userActivity/${id}`, name: 'My Activity' },
      ];
      dispatch(update_breadcrumb(breadcrumb));
    }
  }, []);

  useEffect(() => {
    onFilteLoginActivity(loginActivity.startDate);
    onFilteMarkedDMCAActivity(markedDMCA.startDate);
    onFilteGeneratedDMCAActivity(generatedDMCA.startDate);
    onFilterKeywordActivity(keywordActivity.startDate);
    onFilterCategoryActivity(categoryActivity.startDate);
  }, []);

  const handleChangeLoginActivityRange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setLoginActivity({ ...loginActivity, range: e.target.value });
    switch (e.target.value) {
      case '7days':
        onFilteLoginActivity(new Date(currentDate.getTime() - 86400000 * 7));
        break;
      case '30days':
        onFilteLoginActivity(new Date(currentDate.getTime() - 86400000 * 30));
        break;
      case '90days':
        onFilteLoginActivity(new Date(currentDate.getTime() - 86400000 * 90));
        break;
    }
  };
  const handleChangeMarkedDMCAARange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setMarkedDMCA({ ...markedDMCA, range: e.target.value });

    switch (e.target.value) {
      case '7days':
        onFilteMarkedDMCAActivity(new Date(currentDate.getTime() - 86400000 * 7));
        break;
      case '30days':
        onFilteMarkedDMCAActivity(new Date(currentDate.getTime() - 86400000 * 30));
        break;
      case '90days':
        onFilteMarkedDMCAActivity(new Date(currentDate.getTime() - 86400000 * 90));
        break;
    }
  };
  const handleChangeGeneratedDMCAARange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setGeneratedDMCA({ ...generatedDMCA, range: e.target.value });

    switch (e.target.value) {
      case '7days':
        onFilteGeneratedDMCAActivity(new Date(currentDate.getTime() - 86400000 * 7));
        break;
      case '30days':
        onFilteGeneratedDMCAActivity(
          new Date(currentDate.getTime() - 86400000 * 30)
        );
        break;
      case '90days':
        onFilteGeneratedDMCAActivity(
          new Date(currentDate.getTime() - 86400000 * 90)
        );
        break;
    }
  };
  const handleChangeKeywordActivityRange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setKeywordActivity({ ...keywordActivity, range: e.target.value });
    setCategoryActivity({ ...categoryActivity, range: e.target.value });
    switch (e.target.value) {
      case '7days':
        onFilterKeywordActivity(new Date(currentDate.getTime() - 86400000 * 7));
        onFilterCategoryActivity(new Date(currentDate.getTime() - 86400000 * 7));
        break;
      case '30days':
        onFilterKeywordActivity(new Date(currentDate.getTime() - 86400000 * 30));
        onFilterCategoryActivity(new Date(currentDate.getTime() - 86400000 * 30));

        break;
      case '90days':
        onFilterKeywordActivity(new Date(currentDate.getTime() - 86400000 * 90));
        onFilterCategoryActivity(new Date(currentDate.getTime() - 86400000 * 90));
        break;
    }
  };

  const onFilteLoginActivity = (startDate: Date) => {
    dispatch(updateIsLoading(true));
    const obj = {
      StartDateTime: startDate,
      EndDateTime: new Date(),
    };
    //login activity
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/users/${id}/activity/authentication?${queryString}`;
    axiosInstance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          setLoginResponse(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const onFilteMarkedDMCAActivity = (startDate: Date) => {
    dispatch(updateIsLoading(true));
    const obj = {
      StartDateTime: startDate,
      EndDateTime: new Date(),
    };
    //Marked DMCA
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/users/${id}/activity/mark-preference?${queryString}`;
    axiosInstance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          setPieChartResponse(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const onFilteGeneratedDMCAActivity = (startDate: Date) => {
    dispatch(updateIsLoading(true));
    const obj = {
      StartDateTime: startDate,
      EndDateTime: new Date(),
    };
    //generated DMCA
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url3 = `/users/${id}/activity/dmca-files?${queryString}`;
    axiosInstance
      .get(url3)
      .then((response) => {
        if (response.status === 200) {
          setDmsaResponse(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const onFilterKeywordActivity = (startDate: Date) => {
    dispatch(updateIsLoading(true));
    const obj = {
      StartDateTime: startDate,
      EndDateTime: new Date(),
    };
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/users/${id}/activity/keywords?${queryString}`;

    axiosInstance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          setKeywordResponse(response.data);
          console.log(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message:
            err.response?.data?.Message || 'Failed to fetch keyword activity.',
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const onFilterCategoryActivity = (startDate: Date) => {
    dispatch(updateIsLoading(true));
    const obj = {
      StartDateTime: startDate,
      EndDateTime: new Date(),
    };
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/users/${id}/activity/categories?${queryString}`;

    axiosInstance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          setCategoryResponse(response.data);
          console.log(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message:
            err.response?.data?.Message || 'Failed to fetch category activity.',
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const srcFileDownload = (row: any) => {
    const obj = {
      isShow: true,
      downloadGuid: row.documentStoreId,
    };
    dispatch(updateDownloadID(obj));
  };

  const viewRecord = (row: any) => {
    navigate(`/dmcaFilesView/${row.dmcaFileId}/${id}`);
  };

  const timeFormat = (date: string) => {
    if (date === null) {
      return '-';
    }
    const index = date.indexOf('.');

    if (index !== -1) {
      const removedString = date.slice(0, index);
      return removedString;
    } else {
      return date;
    }
  };

  return (
    <div className="px-2 py-1 ">
      <PageHeading label="User Activity" />
      <div className="bg-white p-2 rounded-sm shadow-lg">
        <div className="p-1 rounded-sm">
          <div className="flex items-center justify-between p-1">
            <div className="text-lg">User Login activity</div>
            <div className="flex items-center space-x-2">
              <Dropdown
                label={'Select Range'}
                name={'range'}
                value={loginActivity.range}
                initialOption={{ name: 'Last 7 days', id: '7days' }}
                options={[
                  { name: 'Last 30 days', id: '30days' },
                  { name: 'Last 90 days', id: '90days' },
                ]}
                onChange={handleChangeLoginActivityRange}
              />
            </div>
          </div>

          <MuiTable
            columns={columns}
            rows={loginResponse.map((item: any) => ({
              date: item?.date?.substring(0, 10),
              loginTime: timeFormat(item.loginTime),
              logoutTime: timeFormat(item.logoutTime),
            }))}
          />
        </div>
        {userInfo.role !== 1 && (
          <>
            <div className="p-2 mt-2 rounded-sm">
              <div className="flex items-center justify-between p-1">
                <div className="text-lg">Weblink activity</div>
                <div className="flex items-center space-x-2">
                  <Dropdown
                    label={'Select Range'}
                    name={'range'}
                    initialOption={{ name: 'Last 7 days', id: '7days' }}
                    options={[
                      { name: 'Last 30 days', id: '30days' },
                      { name: 'Last 90 days', id: '90days' },
                    ]}
                    onChange={handleChangeMarkedDMCAARange}
                  />
                </div>
              </div>
              <div className="w-full sm:flex items-center justify-center sm:space-x-6 mt-6 px-4">
                {/* DMCA Marked Card */}
                <div className="group w-full sm:w-1/3 flex flex-wrap justify-center h-[160px] items-center rounded-2xl flex-col p-6 text-center relative overflow-hidden bg-red-50 border border-red-300 shadow-lg transition-all duration-300 ">
                  <div className="relative z-10 flex flex-col items-center space-y-3">
                    <div className="p-2 rounded-full bg-red-500/20">
                      <TrendingUp className="w-5 h-5 text-red-600" />
                    </div>
                    <div className="text-sm font-medium text-red-800/90 tracking-wide">
                      {markedDmcaCountLables.markedDMCA}
                    </div>
                    <div className="text-2xl font-bold text-red-900 drop-shadow-sm">
                      {pieChartResponse.dmcaMarkedCount}
                    </div>
                  </div>
                </div>
                {/* Marked for Revisit Card */}
                <div className="group w-full sm:w-1/3 sm:mt-0 mt-4 flex justify-center h-[160px] items-center rounded-2xl flex-col p-6 text-center relative overflow-hidden bg-amber-50 border border-amber-300 shadow-lg transition-all duration-300">
                  <div className="relative z-10 flex flex-col items-center space-y-3">
                    <div className="p-2 rounded-full bg-amber-500/20">
                      <RotateCcw className="w-5 h-5 text-amber-600" />
                    </div>
                    <div className="text-sm font-medium text-amber-800/90 tracking-wide">
                      {markedDmcaCountLables.markedRevisit}
                    </div>
                    <div className="text-2xl font-bold text-amber-900 drop-shadow-sm">
                      {pieChartResponse.revisitedMarkedCount}
                    </div>
                  </div>
                </div>
                {/* Ignored Card */}
                <div className="group w-full sm:w-1/3 sm:mt-0 mt-4 flex justify-center h-[160px] items-center rounded-2xl flex-col p-6 text-center relative overflow-hidden bg-emerald-50 border border-emerald-500 shadow-lg transition-all duration-300 ">
                  <div className="relative z-10 flex flex-col items-center space-y-3">
                    <div className="p-2 rounded-full bg-emerald-500/20">
                      <EyeOff className="w-5 h-5 text-emerald-600" />
                    </div>
                    <div className="text-sm font-medium text-emerald-800/90 tracking-wide">
                      {markedDmcaCountLables.ignored}
                    </div>
                    <div className="text-2xl font-bold text-emerald-900 drop-shadow-sm">
                      {pieChartResponse.ignoredMarkedCount}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-2 rounded-sm mt-3">
              <div className="flex items-center justify-between p-1">
                <div className="text-lg">DMCA Files</div>
                <div className="flex items-center space-x-2">
                  <Dropdown
                    label={'Select Range'}
                    name={'range'}
                    initialOption={{ name: 'Last 7 days', id: '7days' }}
                    options={[
                      { name: 'Last 30 days', id: '30days' },
                      { name: 'Last 90 days', id: '90days' },
                    ]}
                    onChange={handleChangeGeneratedDMCAARange}
                  />
                </div>
              </div>
              <MuiTable
                columns={column2}
                rows={dmcaResponse}
                onSrcFileDownload={srcFileDownload}
                onViewHandler={viewRecord}
                showView={true}
              />
            </div>
          
            <div className="border mt-3 p-3 rounded">
              <div className="flex justify-end">
                {' '}
                <Dropdown
                  label={'Select Range'}
                  name={'range'}
                  initialOption={{ name: 'Last 7 days', id: '7days' }}
                  value={keywordActivity.range}
                  options={[
                    { name: 'Last 30 days', id: '30days' },
                    { name: 'Last 90 days', id: '90days' },
                  ]}
                  onChange={handleChangeKeywordActivityRange}
                />
              </div>
              <div className="flex flex-col md:flex-row gap-4 w-full max-w-7xl mx-auto">
                {userInfo.role === 2 && ( 
                  <div className="w-full md:w-1/2">
                  <div className="p-3">
                    <h3 className="text-lg text-gray-800 mb-6 text-center">
                      Category Management
                    </h3>
                    {/* Cards Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4">
                      {/* Created Categories */}
                      <div className="group flex justify-center h-[160px] items-center rounded-xl flex-col p-6 text-center relative overflow-hidden bg-green-50 border border-green-300 shadow-lg transition-all duration-300 ">
                        <div className="absolute inset-0 bg-white/5 to-transparent opacity-50"></div>
                        <div className="relative z-10 flex flex-col items-center space-y-3">
                          <div className="p-2 rounded-full bg-green-300/20">
                            <Plus className="w-5 h-5 text-green-600" />
                          </div>
                          <div className="text-sm font-medium text-green-700/90 tracking-wide text-center">
                            {categoryLabels.created}
                          </div>
                          <div className="text-2xl font-bold text-green-800 drop-shadow-sm">
                            {categoryResponse.created}
                          </div>
                        </div>
                      </div>
                      {/* Activated Categories */}
                      {/* <div className="group flex justify-center h-[160px] items-center rounded-xl flex-col p-6 text-center relative overflow-hidden bg-blue-50 border border-blue-300 shadow-lg transition-all duration-300 ">
                        <div className="absolute inset-0 bg-white/5 to-transparent opacity-50"></div>
                        <div className="relative z-10 flex flex-col items-center space-y-3">
                          <div className="p-2 rounded-full bg-blue-300/20">
                            <CheckCircle className="w-5 h-5 text-blue-600" />
                          </div>
                          <div className="text-sm font-medium text-blue-700/90 tracking-wide text-center">
                            {categoryLabels.activated}
                          </div>
                          <div className="text-2xl font-bold text-blue-800 drop-shadow-sm">
                            {categoryResponse.activateCategory}
                          </div>
                        </div>
                      </div> */}
                      {/* Deactivated Categories */}
                      {/* <div className="group flex justify-center h-[160px] items-center rounded-xl flex-col p-6 text-center relative overflow-hidden bg-gray-50 border border-gray-300 shadow-lg transition-all duration-300 ">
                        <div className="absolute inset-0 bg-white/5 to-transparent opacity-50"></div>
                        <div className="relative z-10 flex flex-col items-center space-y-3">
                          <div className="p-2 rounded-full bg-gray-200/20">
                            <MinusCircle className="w-5 h-5 text-gray-700" />
                          </div>
                          <div className="text-sm font-medium text-gray-700/90 tracking-wide text-center">
                            {categoryLabels.deactivated}
                          </div>
                          <div className="text-2xl font-bold text-gray-800 drop-shadow-sm">
                            {categoryResponse.deactivateCategory}
                          </div>
                        </div>
                      </div> */}
                      {/* Deleted Categories */}
                      <div className="group flex justify-center h-[160px] items-center rounded-xl flex-col p-6 text-center relative overflow-hidden bg-red-50 border border-red-300 shadow-lg transition-all duration-300 ">
                        <div className="absolute inset-0 bg-white/5 to-transparent opacity-50"></div>
                        <div className="relative z-10 flex flex-col items-center space-y-3">
                          <div className="p-2 rounded-full bg-red-300/20">
                            <Trash2 className="w-5 h-5 text-red-600" />
                          </div>
                          <div className="text-sm font-medium text-red-700/90 tracking-wide text-center">
                            {categoryLabels.deleted}
                          </div>
                          <div className="text-2xl font-bold text-red-800 drop-shadow-sm">
                            {categoryResponse.deleted}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
               
                {/* Keyword Management Section */}
                <div className={`w-full ${userInfo.role === 2 && 'md:w-1/2'}`}>
                  <div className=" p-3">
                    <h3 className="text-lg text-gray-800 mb-6 text-center">
                      Keyword Management
                    </h3>

                    <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4">
                      {/* Created Keywords */}
                      <div className="group w-full sm:w-1/2 flex flex-wrap justify-center h-[160px] items-center rounded-xl flex-col p-6 text-center relative overflow-hidden bg-green-50 border border-green-300 shadow-lg transition-all duration-300">
                        <div className="absolute inset-0 bg-white/5 to-transparent opacity-50"></div>
                        <div className="relative z-10 flex flex-col items-center space-y-3">
                          <div className="p-2 rounded-full bg-green-300/50">
                            <Plus className="w-5 h-5 text-green-600" />
                          </div>
                          <div className="text-sm font-medium text-green-700/90 tracking-wide">
                            {keywordLabels.created}
                          </div>
                          <div className="text-2xl font-bold text-green-800 drop-shadow-sm">
                            {keywordResponse.created}
                          </div>
                        </div>
                      </div>
                      {/* Deleted Keywords */}
                      <div className="group w-full sm:w-1/2 flex justify-center h-[160px] items-center rounded-xl flex-col p-6 text-center relative overflow-hidden bg-red-50 border border-red-300 shadow-lg transition-all duration-300 ">
                        <div className="absolute inset-0 bg-white/5 to-transparent opacity-50"></div>
                        <div className="relative z-10 flex flex-col items-center space-y-3">
                          <div className="p-2 rounded-full bg-red-300/20">
                            <Trash2 className="w-5 h-5 text-red-600" />
                          </div>
                          <div className="text-sm font-medium text-red-700/90 tracking-wide">
                            {keywordLabels.deleted}
                          </div>
                          <div className="text-2xl font-bold text-red-800 drop-shadow-sm">
                            {keywordResponse.deleted}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserActivity;
